import { createFileRoute } from '@tanstack/react-router'
import TagsForm from 'Admin/components/tags/TagsForm'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/tags')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <TagsForm />
        </Guard>
    ),
})
